module.exports = __webpack_public_path__ + "img/promotion-deco.ca934073.png";